// Smooth scroll for anchor links
(function() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    el && setTimeout(() => el.scrollIntoView({ behavior: 'smooth', block: 'start' }), 100);
  };

  const init = () => {
    document.querySelectorAll('a[href^="/#"], a[href^="#"]:not([href="#"])').forEach(a => {
      a.addEventListener('click', function(e) {
        const id = this.getAttribute('href').replace(/^\/?#/, '');
        if (id) {
          e.preventDefault();
          scrollTo(id);
          history.pushState?.(null, null, this.getAttribute('href'));
        }
      });
    });
    window.location.hash && scrollTo(window.location.hash.substring(1));
  };

  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();
